


























import { Vue, Component } from 'vue-property-decorator';
import { Subscription } from 'vue-rx-decorators';
import { RouteNames } from './_routes';
import { Cache } from '../../common/cache';
import { Facilities, User } from '@lantern/lantern-sdk';

@Component({
    components: {},
})
export default class MainComponent extends Vue {
  RouteNames = RouteNames;

  @Subscription(() => Cache.instance.facility)
  facility!: Facilities.Document | null;

  @Subscription(() => Cache.instance.user)
  user!: User.Info | null;

  async created() {}

  signOut() {
      window.localStorage.clear();
      location.reload();
  }
}
